import { render, staticRenderFns } from "./page006.vue?vue&type=template&id=cfa66e20&scoped=true&"
import script from "./page006.vue?vue&type=script&lang=js&"
export * from "./page006.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa66e20",
  null
  
)

export default component.exports